module.exports = __webpack_public_path__ + "static/media/camera.e1229145.png";